import { cargoes } from '../entities/cargoes-sidecar'
import { ICargoType } from '../entities/cargoesData'
import { stacks } from '../entities/stacks-sidecar'
import { distance } from '../lib/distance-sidecar'
import { jobLogger } from './jobLogger-sidecar'
import { IJob, ITask, ITaskType, registerTask } from './jobs'
import { jobs } from './jobs-sidecar'

const type: ITaskType = 'stack-cargo'
export const register = () => registerTask(type, runTask)

export function createTask_stackCargo(
  i: number,
  j: number,
  cargoType: ICargoType,
): ITask {
  return jobs._createTask(i, j, type, {
    allowFromStack: false,
    cargoType,
  })
}

function runTask(job: IJob, task: ITask) {
  jobLogger.assertTaskType(task, type)
  let m = jobLogger.assertReserved(job)

  // Are we at the right spot?
  if (!distance.isAt(m.i, m.j, task.i, task.j)) {
    return jobLogger.failTask(job, task, 'wrong spot')
  }

  let cargoHere = m.carryingCargo
  if (cargoHere) {
    if (cargoHere.data.type !== task.cargoType) {
      return jobLogger.failTask(job, task, 'wrong carried type')
    }
  }
  if (!cargoHere) {
    cargoHere = cargoes.findAtSpot(
      m.i,
      m.j,
      (c) => c.data.type == task.cargoType,
      false,
    )
    // Cargo went missing
    if (!cargoHere) {
      return jobLogger.failTask(job, task, 'cargo lost')
    }
  }
  if (cargoHere.inStack) {
    return jobLogger.failTask(job, task, 'cargo already stacked')
  }

  let stackHere = stacks.findAtSpot(
    m.i,
    m.j,
    (c) => c.holdsType === task.cargoType,
  )
  // Stack went missing
  if (!stackHere) {
    return jobLogger.failTask(job, task, 'stack lost spot')
  }

  if (!stacks.addToStack(stackHere, cargoHere)) {
    return jobLogger.failTask(job, task, 'cant add to stack')
  }

  return jobLogger.succeedTask(job, task)
  // TODO: check to make sure there's a cargo here of the correct type, and put it in the stack
  // task.isComplete = true
}
